import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, Link, useLocation } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../components/LifeSection.css";
import '../../components/PopularEvents.css';
import '../../components/AchieversSection.css';
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolLifePage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  /* 🔹 SEPARATE REFS */
  const imageRefs = useRef([]);          // FIX: image-only animation
  const titleRef = useRef(null);
  const sectionRef = useRef(null);

  const [section, setSection] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [achieversVisible, setAchieversVisible] = useState([]);
  const [newsletter, setNewsLetter] = useState([]);
  const [technoEcho, setTechnoEcho] = useState([]);
  const [prospectus, setProspectus] = useState([]);
  const [newsClippingImages, setNewsClippingImages] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isVisible, setIsVisible] = useState(true);

  const [achievers, setAchievers] = useState([]);
  const achieversRef = useRef(null);

  const [eventsVisible, setEventsVisible] = useState(false);
  const eventsRef = useRef(null);


  /* 🔥 FULLSCREEN MODAL STATE */
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalCaption, setModalCaption] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalType, setModalType] = useState("gallery");


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);


  /* ---------------- LIFE CONTENT ---------------- */
  useEffect(() => {
    if (!school_slug) return;

    setLoading(true);
    setError("");

    axios
      .get(
        `${baseAPIUrl}api/life_at_tigps/get/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setSection(res.data.data.section);
          setBlocks(res.data.data.blocks || []);
        } else {
          setError("No content available");
        }
      })
      .catch(() => setError("Failed to load content"))
      .finally(() => setLoading(false));
  }, [school_slug]);

  /* ---------- IMAGE ANIMATION ---------- */
  useEffect(() => {
    if (!blocks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    imageRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [blocks]);

  /* ---------------- GALLERY VISIBILITY  ---------------- */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (titleRef.current) observer.observe(titleRef.current);
    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  /* ---------------- RESPONSIVE SLIDER ---------------- */
  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setSlidesToShow(w <= 600 ? 1 : w <= 992 ? 2 : 4);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------- GALLERY (PUBLIC API) ---------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_gallery/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setGalleryImages(res.data.data || []);
        }
      })
      .catch((err) => console.error("Gallery API error", err));
  }, [school_slug]);

  /* ---------- VIDEO (PUBLIC API) ---------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_videos/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setVideos(res.data.data || []);
        }
      })
      .catch((err) => console.error("Video API error", err));
  }, [school_slug]);

  /* ---------- News clippings (PUBLIC API) ---------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_news_clippings/${finalSchoolSlug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setNewsClippingImages(res.data.data || []);
        }
      })
      .catch((err) => console.error("News clippings API error", err));
  }, [school_slug]);

  /* ---------- EVENTS (PUBLIC API) ---------- */
  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_events/${school_slug}`
      )
      .then((res) => {
        console.log("FRONT EVENTS:", res.data);

        if (res.data.status === 1 && Array.isArray(res.data.data)) {
          setEventList(res.data.data);
        } else {
          setEventList([]);
        }
      })
      .catch((err) => {
        console.error("Event API error", err);
        setEventList([]);
      });
  }, [school_slug]);


  // events visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setEventsVisible(true);
            observer.disconnect(); // trigger once
          }
        });
      },
      { threshold: 0.2 }
    );

    if (eventsRef.current) {
      observer.observe(eventsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  /* ---------------- FETCH ACHIEVERS ---------------- */
  useEffect(() => {
    if (!school_slug || school_slug.trim() === "") return;

    setLoading(true);

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_achievers/${encodeURIComponent(
          school_slug.trim()
        )}`,
        { withCredentials: true }
      )
      .then((res) => {
        console.log("ACHIEVERS API RESPONSE:", res.data);

        if (res.data?.status == 1 && Array.isArray(res.data.data)) {
          setAchievers(res.data.data);
        } else {
          setAchievers([]);
        }
      })
      .catch((err) => {
        console.error("Achiever API error:", err);
        setAchievers([]);
      })
      .finally(() => setLoading(false));
  }, [school_slug]);

  // Acheivers visibility

  useEffect(() => {
    if (!achieversRef.current || achievers.length === 0) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAchieversVisible(true);
          observer.disconnect(); // ✅ trigger once
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(achieversRef.current);

    return () => observer.disconnect();
  }, [achievers]);

  // For gallery
  const settings = {

    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: isVisible,
    autoplaySpeed: 2000,
    pauseOnHover: true
  };

  // For acheiver
  const achieverSettings = {

    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const eventsettings = {

    infinite: true,
    speed: 700,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: isVisible,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: 'linear',
    centerMode: false,
    centerPadding: '0px',
    arrows: true   // 🔥 IMPORTANT
  };

  const tableStyle = {
    backgroundColor: 'white',
    // border: '2px solid rgb(100, 19, 32)',
    borderCollapse: "collapse",
    width: "100%",
    maxWidth: "1000px",
    minWidth: '600px',
    color: '#333',
    borderRadius: '10px',
    overflow: 'hidden',
    fontFamily: 'Lora',
    margin: "0px auto",
  };

  const tableStyle1 = {
    backgroundColor: 'white',
    border: '2px solid rgb(100, 19, 32)',
    borderCollapse: "collapse",
    width: "100%",
    maxWidth: "1000px",
    minWidth: '600px',
    color: '#333',
    borderRadius: '10px',
    overflow: 'hidden',
    fontFamily: 'Lora',
    margin: "0px auto",
  };

  const thStyle = {
    padding: "15px",
    border: "1px solid #ddd",
    color: "rgb(100, 19, 32)",
    textAlign: 'center',
    fontSize: '1.1rem',
    fontFamily: 'Lora'
  };
  const tdStyle = {
    padding: '12px 15px',
    border: "1px solid #ddd",
    textAlign: "center",
    fontSize: '0.9rem',
    fontFamily: 'Metropolis-regular'
  };

  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_newsletter/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setNewsLetter(res.data.data || []);
        }
      })
      .catch((err) => console.error("Newsletter API error", err));
  }, [school_slug]);

  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_techno_echo/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setTechnoEcho(res.data.data || []);
        }
      })
      .catch((err) => console.error("Techno Echo API error", err));
  }, [school_slug]);

  useEffect(() => {
    if (!school_slug) return;

    axios
      .get(
        `${baseAPIUrl}admin/life_at_tigps/get_prospectus/${school_slug}`
      )
      .then((res) => {
        if (res.data.status === 1) {
          setProspectus(res.data.data || []);
        }
      })
      .catch((err) => console.error("Prospectus API error", err));
  }, [school_slug]);


  /* ================= BEYOND ACADEMICS CAROUSEL ================= */
  const carouselRef = useRef(null);
  const currentSlideRef = useRef(0);

  const showSlide = (index) => {
    if (!carouselRef.current) return;
    const slides = carouselRef.current.querySelectorAll(".carousel-slide");
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  };

  const nextSlide = () => {
    if (!carouselRef.current) return;
    const slides = carouselRef.current.querySelectorAll(".carousel-slide");
    if (!slides.length) return;

    currentSlideRef.current =
      (currentSlideRef.current + 1) % slides.length;

    showSlide(currentSlideRef.current);
  };

  const prevSlide = () => {
    if (!carouselRef.current) return;
    const slides = carouselRef.current.querySelectorAll(".carousel-slide");
    if (!slides.length) return;

    currentSlideRef.current =
      (currentSlideRef.current - 1 + slides.length) % slides.length;

    showSlide(currentSlideRef.current);
  };

  /* INIT */
  useEffect(() => {
    showSlide(0);
  }, []);

  const [activeIndex, setActiveIndex] = useState(0); // first slide active

  /* AUTO SLIDE */
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % blocks.length);
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, []);


  /* 🔥 MODAL FUNCTIONS */

  const openModal = (index, type = "gallery") => {

    const list = type === "gallery" ? galleryImages : newsClippingImages;
    const folder = type === "gallery" ? "gallery" : "news_clipping";

    const img = list[index];
    if (!img) return;

    setCurrentIndex(index);
    setModalType(type);

    setModalImage(
      `${baseAPIUrl}assets/images/${folder}/${img.image_name}`
    );

    setModalCaption(img.image_content || "");

    setIsModalOpen(true);
    document.body.style.overflow = "hidden";

  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const nextImage = (e) => {
    e.stopPropagation();

    const list = modalType === "gallery" ? galleryImages : newsClippingImages;
    const folder = modalType === "gallery" ? "gallery" : "news_clipping";

    const nextIndex = (currentIndex + 1) % list.length;
    const img = list[nextIndex];

    setCurrentIndex(nextIndex);

    setModalImage(
      `${baseAPIUrl}assets/images/${folder}/${img.image_name}`
    );

    setModalCaption(img.image_content || "");
  };

  const prevImage = (e) => {
    e.stopPropagation();

    const list = modalType === "gallery" ? galleryImages : newsClippingImages;
    const folder = modalType === "gallery" ? "gallery" : "news_clipping";

    const prevIndex = (currentIndex - 1 + list.length) % list.length;
    const img = list[prevIndex];

    setCurrentIndex(prevIndex);

    setModalImage(
      `${baseAPIUrl}assets/images/${folder}/${img.image_name}`
    );

    setModalCaption(img.image_content || "");
  };


  return (
    <>
      <div>

        {/* HERO */}
        <SchoolInnerPageBanner />

        {/* LIFE AT TIGPS */}
        <section
          id="beyond-academics"
          className="rts-campus rts-section-padding"
          style={{ background: "rgb(100, 19, 32)", padding: "80px 20px" }}
        >
          <div className="container pb--20">

            <h2 className="beyond-academics mb-4 text-center text-white">{section?.heading}</h2>
            <p className="beyond-academic-sub text-center text-white mt-2">
              {section?.intro_paragraph}
            </p>

            <div className="carousel-wrapper">
              <div className="carousel-content">
                <div className="carousel-image-wrapper" ref={carouselRef}>
                  {blocks.map((sec, index) => (
                    <div className={`carousel-slide ${index === activeIndex ? "active" : ""}`}>
                      <img
                        src={sec.block_image}
                        alt={sec.block_heading}
                        className="campus-video-img"
                      />
                      <div className="video-overlay-box">
                        <h3 className="overlay-title">{sec.block_heading}</h3>
                        <p className="overlay-text">
                          {sec.block_paragraph}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="carousel-controls">
                <button className="slick-arrow slick-prev" onClick={prevSlide}>‹</button>
                <button className="slick-arrow slick-next" onClick={nextSlide}>›</button>
              </div>
            </div>
          </div>
        </section>

        {/* Gallery SLIDER */}
        <section id="gallery" ref={sectionRef} className="life-section" style={{ background: "#fff", padding: "80px 20px" }}>
          <div className="life-container">

            {/* GALLERY HEADING */}
            <h2 ref={titleRef} className="life-title animate-in" >
              LIFE AT {school_slug.toUpperCase().replace(/-/g, " - ")}
            </h2>

            {galleryImages.length > 0 ? (
              <Slider {...settings} className="life-slider">
                {galleryImages.map((img, i) => (
                  <div key={img.id || i} className="life-slide">
                    <div className="life-image">

                      <img
                        src={`${baseAPIUrl}assets/images/gallery/${img.image_name}`}
                        alt="Gallery"
                        style={{ cursor: "pointer" }}
                        onClick={() => openModal(i, "gallery")}
                      />

                      {img.image_content && (
                        <div
                          className="life-overlay"
                          onClick={() => openModal(i, "gallery")}
                        >
                          <p className="life-image-title">{img.image_content}</p>
                        </div>
                      )}

                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <p style={{ textAlign: "center", color: "rgb(100, 19, 32)" }}>
                No gallery images available
              </p>
            )}


          </div>
        </section>

        {/* VIDEO SLIDER */}
        <section id="videos" ref={sectionRef} className="life-section" style={{ background: "rgb(248, 249, 250)", padding: "80px 20px" }}>
          <div className="life-container">

            {/* VIDEO HEADING */}
            <h2 ref={titleRef} className="life-title animate-in" >
              VIDEOS
            </h2>

            {videos.length > 0 ? (
              <Slider {...settings} className="life-slider">
                {videos.map((img, i) => (
                  <div key={img.id || i} className="life-slide">
                    <div className="life-image">
                      <a href={img.image_url} target="_blank">
                        <img
                          src={`${baseAPIUrl}assets/images/videos/${img.image_name}`}
                          alt={img.image_content || "Video"}
                        />
                        {img.image_content && (
                          <div className="life-overlay">
                            <p className="life-image-title">{img.image_content}</p>
                          </div>
                        )}
                      </a>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <p style={{ textAlign: "center", color: "rgb(100, 19, 32)" }}>
                No Video Thumbnail available
              </p>
            )}

          </div>
        </section>

        {/* Latest News & Updates SLIDER */}
        <section id="news-updates" ref={eventsRef} className={`events-section ${eventsVisible ? "animate-in" : "hidden"}`} style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)' }}>
          <div className="events-container">

            {/* Latest News & Updates SLIDER HEADING */}
            <h2 className="events-title" style={{ color: 'rgb(255, 255, 255)' }}>LATEST NEWS & UPDATES</h2>

            {newsClippingImages.length > 0 ? (
              <Slider {...settings} className="news-slider">
                {newsClippingImages.map((img, i) => (
                  <div key={img.id || i} className="news-slide">
                    <div className="life-image">
                      <img
                        src={`${baseAPIUrl}assets/images/news_clipping/${img.image_name}`}
                        alt="News"
                        style={{ cursor: "pointer" }}
                        onClick={() => openModal(i, "news")}
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <p style={{ textAlign: "center", color: "#fff" }}>
                No News & updates available
              </p>
            )}

          </div>
        </section>

        {/* Events HEADING */}
        <section id="celebratory-events"
          ref={eventsRef}
          className={`events-section ${eventsVisible ? "animate-in" : "hidden"}`}
          style={{ padding: '80px 6vw', background: 'rgb(248, 249, 250)' }}
        >
          <div className="events-container pb-5">
            <h2 className="events-title">CELEBRATORY EVENTS</h2>

            {eventList.length > 0 ? (
              <Slider {...eventsettings} className="events-slider">
                {eventList.map((event) => (
                  <div key={event.id} className="event-slide">
                    <div className="event-card">

                      <div className="event-image">
                        <img
                          src={
                            event.images?.[0]?.image_name
                              ? `${baseAPIUrl}assets/images/events/${event.images[0].image_name}`
                              : "/pictures/default-event.jpg"
                          }
                          alt={event.event_name}
                          onError={(e) =>
                            (e.target.src = "/pictures/default-event.jpg")
                          }
                        />
                      </div>

                      <div className="event-content">
                        <h4 style={{ fontFamily: "Lora", fontSize: "1.2rem", color: 'rgb(100, 19, 32)' }}>{event.event_name}</h4>

                        <Link
                          to={`/${school_slug}/events/${event.id}`}
                          className="event-btn"
                        >
                          Read more
                        </Link>
                      </div>

                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <p style={{ textAlign: "center" }}>No events available</p>
            )}
          </div>
        </section>

        <section id="news-letter" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>NEWSLETTER</h2>
            <div className="table-responsive">
              <table style={tableStyle1}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={thStyle}>SL NO.</th>
                    <th style={thStyle}>DOCUMENTS</th>
                    <th style={thStyle}>UPLOADED DOCUMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {newsletter.length > 0 ? (
                    newsletter.map((row, index) => (
                      <tr key={index}>
                        <td style={tdStyle}>{index + 1}</td>
                        <td style={tdStyle}>{row.information}</td>
                        <td style={tdStyle}>
                          {row.file_name && row.file_name !== "#" ? (
                            <a
                              href={`${baseAPIUrl}assets/images/newsletter/${row.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="click-link"
                            >
                              Click here
                            </a>
                          ) : (
                            "NA"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                      <td style={tdStyle} colSpan="3">
                        No Newsletter found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </section>

        <section id="techno-echo" style={{ padding: '80px 20px', background: '#fff' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '600', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora', color: 'rgb(100, 19, 32)' }}>TECHNO ECHO</h2>
            <div className="table-responsive">
              <table style={tableStyle}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={thStyle}>SL NO.</th>
                    <th style={thStyle}>DOCUMENTS</th>
                    <th style={thStyle}>UPLOADED DOCUMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {technoEcho.length > 0 ? (
                    technoEcho.map((row, index) => (
                      <tr key={index + 1}>
                        <td style={tdStyle}>{index + 1}</td>
                        <td style={tdStyle}>{row.information}</td>
                        <td style={tdStyle}>
                          {row.file_name && row.file_name !== "#" ? (
                            <a
                              href={`${baseAPIUrl}assets/images/techno_echo/${row.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="click-link"
                            >
                              Click here
                            </a>
                          ) : (
                            "NA"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                      <td style={tdStyle} colSpan="3">
                        No Techno Echo found
                      </td>
                    </tr>
                  )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section id="prospectus" style={{ padding: '80px 20px', background: 'rgb(100, 19, 32)', color: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>TIGPS PROSPECTUS</h2>
            <div className="table-responsive">
              <table style={tableStyle1}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={thStyle}>SL NO.</th>
                    <th style={thStyle}>DOCUMENTS</th>
                    <th style={thStyle}>UPLOADED DOCUMENTS</th>
                  </tr>
                </thead>
                <tbody>
                  {prospectus.length > 0 ? (
                    prospectus.map((row, index) => (
                      <tr key={index + 1}>
                        <td style={tdStyle}>{index + 1}</td>
                        <td style={tdStyle}>{row.information}</td>
                        <td style={tdStyle}>
                          {row.file_name && row.file_name !== "#" ? (
                            <a
                              href={`${baseAPIUrl}assets/images/prospectus/${row.file_name}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="click-link"
                            >
                              Click here
                            </a>
                          ) : (
                            "NA"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                      <td style={tdStyle} colSpan="3">
                        No Prospectus found
                      </td>
                    </tr>
                  )
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {isModalOpen && (
          <div className="fullscreen-modal" onClick={closeModal}>

            <span className="modal-close" onClick={closeModal}>
              &times;
            </span>

            <button className="modal-prev" onClick={prevImage}>
              ‹
            </button>

            <div
              className="fullscreen-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={modalImage} alt="Full View" />

              {modalCaption && (
                <p className="modal-caption">{modalCaption}</p>
              )}
            </div>

            <button className="modal-next" onClick={nextImage}>
              ›
            </button>

          </div>
        )}
      </div>
    </>
  );
};

export default SchoolLifePage;
